import type { GradivostChatResponse } from "@/api/schemas";
import type { FeasibilityValues } from "@/features/projects/useProjectStore";

/**
 * G2 — čisti mapper chat odgovora u vrijednosti postojeće forme gradivosti.
 *
 * Fill-empty duh: vraća SAMO polja koja je parse stvarno proizveo — pozivatelj
 * ih merga preko trenutnih vrijednosti forme, pa ništa korisnikovo ne gazi
 * prazninom. Općina se postavlja samo kad je resolver vratio živi slug
 * (nikad pogađanje — D1 lekcija).
 */
export function chatToFormValues(resp: GradivostChatResponse): Partial<FeasibilityValues> {
  const p = resp.parsed;
  const out: Partial<FeasibilityValues> = {};
  if (p.municipality_code) out.municipality_code = p.municipality_code;
  if (p.designation) out.designation = p.designation;
  if (p.building_type) out.building_type = p.building_type;
  if (p.work_type) out.work_type = p.work_type;
  if (p.in_city_center) out.in_city_center = true;
  // Cijelo pitanje ide u Slobodan opis — motor (numeric_checker) iz njega
  // sam čita KIG/KISN/etaže/visinu; obrazac identičan ručnom unosu.
  if (p.context) out.context = p.context;
  return out;
}

/** Auto-run samo kad ništa ne nedostaje — dvosmisleno → potpitanje, ne
 *  pogađanje (Zakon #1/#2 mandata). */
export function isReadyToRun(resp: GradivostChatResponse): boolean {
  return resp.missing.length === 0;
}
